var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { css, html } from "lit";
import { PICInput, customElement } from "../Internals";
import { query, state } from "lit/decorators.js";
import { classMap } from "lit/directives/class-map.js";
import { styleMap } from "lit/directives/style-map.js";
let PICPasswordField = class PICPasswordField extends PICInput {
    constructor() {
        super(...arguments);
        this.showPassword = false;
        this.hasInput = false;
    }
    static get styles() {
        const defaultStyle = css `
          /* TODO: double check if .fa classes is needed, is in main style */
          .fa-2x {
            font-size: 2em;
          }
          .fa {
            position: relative;
            font-size: 20px;
          }
          input::-ms-reveal,
          input::-ms-clear {
            display: none;
          }
          input {
            padding-right: 54.5px;
          }
          .showHideEyeContainer {
            position: absolute;
            display: flex;
            align-items: center;
            right: 16px;
            bottom: 0;
            margin: 1px;
            padding: 1px;
          }
        `;
        return css `
            ${super.styles}
            ${defaultStyle}
    `;
    }
    get submitValue() {
        if (!this.inputField) {
            return '';
        }
        return this.inputField.value;
    }
    connectedCallback() {
        super.connectedCallback();
        this.setAttribute('passwordfield', '');
    }
    handleShow() {
        this.showPassword = !this.showPassword;
    }
    getEyeStyle() {
        let styles = [];
        if (!this.hasInput) {
            styles.push({ 'display': 'none' });
        }
        else if (this.density === 'high') {
            styles.push({ 'font-size': '16px' });
        }
        return styles.length > 0 ? styles.reduce((total, current) => total = Object.assign(Object.assign({}, total), current)) : {};
    }
    getInputHeight() {
        let styles = [];
        switch (this.density) {
            case "old":
                styles.push({ 'height': 'var(--pic-densityOldInputHeight)' });
                break;
            case "low":
                styles.push({ 'height': 'var(--pic-densityLowInputHeight)' });
                break;
            case "medium":
                styles.push({ 'height': 'var(--pic-densityMediumInputHeight)' });
                break;
            case "high":
                styles.push({ 'height': 'var(--pic-densityHighInputHeight)' });
                break;
            case "inline":
                styles.push({ 'height': 'var(--pic-densityInlineInputHeight)' });
                break;
        }
        return styles.length > 0 ? styles.reduce((total, current) => total = Object.assign(Object.assign({}, total), current)) : {};
    }
    calcHasInput(event) {
        this.hasInput = this.submitValue.length > 0;
    }
    handleKeyUp(e) {
        if (e.key === 'Enter') {
            this.enterSubmit(e);
        }
    }
    render() {
        this.setComponentInlineStyle();
        return html `
          <div style=${styleMap(this.getContainerStyle())} class=${classMap(this.getContainerClassMap())}>
            <label class=${classMap(this.classAdder(this.getInputLabelClass(), 'inner-inputLabel'))} for=${'pass'}>${this.label}</label>
            <input
              class=${classMap(this.getInnerInputClass())}
              type=${this.showPassword ? 'text' : 'password'}
              id="pass"
              name="password"
              autocomplete="off"
              passwordfield
              @input=${this.calcHasInput}
              @keyup=${this.handleKeyUp}
            />
            <div 
              class='showHideEyeContainer' 
              style=${styleMap(this.getInputHeight())}
            >
              <i class="fa fa-solid fa-eye showHideEye" style=${styleMap(this.getEyeStyle())} @click=${() => this.handleShow()}></i>
            </div>
          </div>
        `;
    }
};
__decorate([
    query('#pass')
], PICPasswordField.prototype, "inputField", void 0);
__decorate([
    query('.showHideEye')
], PICPasswordField.prototype, "showHideEye", void 0);
__decorate([
    state()
], PICPasswordField.prototype, "showPassword", void 0);
__decorate([
    state()
], PICPasswordField.prototype, "hasInput", void 0);
PICPasswordField = __decorate([
    customElement('pic-password')
], PICPasswordField);
export { PICPasswordField };
//# sourceMappingURL=PICPasswordField.js.map